module.exports = __webpack_public_path__ + "img/IMG_6984_L_Wood.64de26f0.jpg";